export const handleErrorReason = (reason: unknown) => {
  console.error(reason);
  if (typeof reason === "object") {
    return new Error(JSON.stringify(reason));
  }
  return new Error(String(reason));
};

